import React from 'react';
import PropTypes from 'prop-types';

import BBFeaturedStories from '../BBFeaturedStories';
import FeaturedStory from '../../../02_molecules/FeaturedStory';
import ItemWithImage from '../../../02_molecules/Item/ItemWithImage';
import { PTItemWithImage } from '../../../02_molecules/Item/ItemWithImage/prop-types';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

/**
 * Content Grid body block in Drupal.
 */
class BBFeaturedCountryNews extends React.Component {
  featuredStoryIndexPattern = [1, 2, 5, 6, 9, 10, 13, 14];

  constructor(props) {
    super(props);
    // Reorder the second story (first featured story) to be first story to appear on mobile.
    if (props.items.length > 1) {
      this.mobileItems = [props.items[1], props.items[0], ...props.items.slice(2)];
    }
  }

  render() {
    const { title, items, behaviorSettings, uuid } = this.props;

    const classes = [
      'bb',
      'bb-featured-country-news',
      styles['bb-featured-country-news'],
      generateClassNameByBehaviorSettings(behaviorSettings),
    ];

    return (
      <div className={classes.join(' ')} id={uuid}>
        <div className="container">
          {title && <h2>{title}</h2>}

          <BBFeaturedStories className="d-md-none" items={this.mobileItems} />

          <div className="row d-none d-md-flex">
            {items.map((story, index) =>
              this.featuredStoryIndexPattern.includes(index) ? (
                <FeaturedStory key={story.title} {...story} width={8} />
              ) : (
                <div className="col-md-4" key={story.title}>
                  <ItemWithImage isDesktopDescriptionHidden={false} {...story} />
                </div>
              ),
            )}
          </div>
        </div>
      </div>
    );
  }
}

BBFeaturedCountryNews.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape(PTItemWithImage)).isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

BBFeaturedCountryNews.defaultProps = {
  title: '',
  behaviorSettings: null,
  uuid: null,
};

export default BBFeaturedCountryNews;
